<div
  data-slot="empty-content"
  class="empty-content"
  [ngClass]="className"
>
  <ng-content></ng-content>
</div>
